import { render, staticRenderFns } from "./ShopManagement.vue?vue&type=template&id=382fcb5b&"
import script from "./ShopManagement.vue?vue&type=script&lang=js&"
export * from "./ShopManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports